import CustomPaper from '../../containers/Paper'
import CustomButton from '../../components/Button'
import CustomModal from '../../containers/Modal'
import PostModal from '../../components/Modal/PostModal'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { PostDTO } from '../../models/post'
import PostService from '../../services/PostService'
import Post from './Post'
import { ReactNode, useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { isAdmin } from '../../helpers/utils'
import { AppRoutes } from '../../helpers/routes'
import NoResults from '../../containers/NoResults'
import { CircularProgress } from '@mui/material'
import CustomTabs, { CustomTab } from '../../containers/Tabs'

const HomePage = () => {
    const [posts, setPosts] = useState<PostDTO[]>([])
    const [myPosts, setMyPosts] = useState<PostDTO[]>([])
    const [pendingPosts, setPendingPosts] = useState<PostDTO[]>([])
    const [isNewPostOpen, setIsNewPostOpen] = useState<boolean>(false)
    const [mutate, setMutate] = useState<boolean>(false)
    const [selectedTab, setSelectedTab] = useState<string>('Generales')

    useEffect(() => {
        const postsService = new PostService()
        postsService.getPublishedPosts().then((response) => {
            setPosts(response.data ?? [])
        })
        postsService.getMyPosts().then((response) => {
            setMyPosts(response.data ?? [])
        })
        postsService.getMyPendingPosts().then((response) => {
            setPendingPosts(response.data ?? [])
        })
    }, [mutate])

    const postsList = (posts: PostDTO[], emptyMessage: ReactNode) => {
        return (
            <div className="flex flex-col w-full gap-4 mt-2 md:mt-4">
                <CustomButton
                    startIcon={<AddCircleOutlineIcon />}
                    className="w-fit"
                    secondary
                    onClick={() => setIsNewPostOpen(true)}
                >
                    Crear publicación
                </CustomButton>
                {posts.length > 0 ? (
                    <div className="flex flex-col gap-4">
                        {posts.map((x) => (
                            <div key={x.id}>
                                <CustomPaper
                                    id={x.id}
                                    key={x.id}
                                >
                                    <Post
                                        info={x}
                                        setMutate={setMutate}
                                    />
                                </CustomPaper>
                            </div>
                        ))}
                    </div>
                ) : (
                    emptyMessage
                )}
            </div>
        )
    }

    const tabs: CustomTab[] = [
        {
            value: 'Generales',
            label: <div className="flex gap-1 items-center">Generales</div>,
            content: posts ? (
                postsList(
                    posts,
                    <CustomPaper>
                        <NoResults
                            title="No se encontraron publicaciones"
                            subtitle="¡Sé el primero en crear una!"
                        />
                    </CustomPaper>,
                )
            ) : (
                <div className="flex w-full justify-center">
                    <CircularProgress
                        className="m-2 md:m-5 text-primary"
                        size={64}
                    />
                </div>
            ),
        },
        {
            value: 'Propias',
            label: <div className="flex gap-1 items-center">Propias</div>,
            content: myPosts ? (
                postsList(
                    myPosts,
                    <CustomPaper>
                        <NoResults
                            title="No tenés niguna publicación"
                            subtitle="Podés crear una nueva"
                        />
                    </CustomPaper>,
                )
            ) : (
                <div className="flex w-full justify-center">
                    <CircularProgress
                        className="m-2 md:m-5 text-primary"
                        size={64}
                    />
                </div>
            ),
        },
        {
            value: 'Pendientes',
            label: <div className="flex gap-1 items-center">Pendientes</div>,
            content: pendingPosts ? (
                postsList(
                    pendingPosts,
                    <CustomPaper>
                        <NoResults
                            title="No tenés publicaciones pendientes"
                            subtitle="Podés crear una o ver las demás"
                        />
                    </CustomPaper>,
                )
            ) : (
                <div className="flex w-full justify-center">
                    <CircularProgress
                        className="m-2 md:m-5 text-primary"
                        size={64}
                    />
                </div>
            ),
        },
    ]

    return (
        <div className="flex flex-col gap-4 w-full">
            {isAdmin() ? (
                <Navigate to={AppRoutes.news} />
            ) : (
                <>
                    <CustomTabs
                        tabs={tabs}
                        value={selectedTab}
                        setValue={setSelectedTab}
                        gap={4}
                        type="buttons"
                        fullWidth
                    />
                    <CustomModal
                        isOpen={isNewPostOpen}
                        handleClose={() => setIsNewPostOpen(false)}
                    >
                        <PostModal
                            handleClose={() => setIsNewPostOpen(false)}
                            setMutate={setMutate}
                        />
                    </CustomModal>
                </>
            )}
        </div>
    )
}

export default HomePage
